export const getBasicAuthHeader = () => {
    if (window.basicAuthUsername && window.basicAuthPassword) {
        return 'Basic ' + btoa(window.basicAuthUsername + ':' + window.basicAuthPassword);
    }

    return null;
}
